import React from 'react';
import CitologiaPage from './citologia.page';
function Citologia () {
  return <CitologiaPage />;
}

export default Citologia;



// WEBPACK FOOTER //
// ./src/pages/citologia/citologia.container.js